export var ELibraryAssetType;
(function (ELibraryAssetType) {
    ELibraryAssetType[ELibraryAssetType["Capsule"] = 0] = "Capsule";
    ELibraryAssetType[ELibraryAssetType["Hero"] = 1] = "Hero";
    ELibraryAssetType[ELibraryAssetType["Logo"] = 2] = "Logo";
    ELibraryAssetType[ELibraryAssetType["Header"] = 3] = "Header";
    ELibraryAssetType[ELibraryAssetType["Icon"] = 4] = "Icon";
    ELibraryAssetType[ELibraryAssetType["HeroBlur"] = 5] = "HeroBlur";
})(ELibraryAssetType || (ELibraryAssetType = {}));
export var EAppReleaseState;
(function (EAppReleaseState) {
    EAppReleaseState[EAppReleaseState["Unknown"] = 0] = "Unknown";
    EAppReleaseState[EAppReleaseState["Unavailable"] = 1] = "Unavailable";
    EAppReleaseState[EAppReleaseState["Prerelease"] = 2] = "Prerelease";
    EAppReleaseState[EAppReleaseState["PreloadOnly"] = 3] = "PreloadOnly";
    EAppReleaseState[EAppReleaseState["Released"] = 4] = "Released";
    EAppReleaseState[EAppReleaseState["Disabled"] = 5] = "Disabled";
})(EAppReleaseState || (EAppReleaseState = {}));
export var EAppLaunchOptionType;
(function (EAppLaunchOptionType) {
    EAppLaunchOptionType[EAppLaunchOptionType["None"] = 0] = "None";
    EAppLaunchOptionType[EAppLaunchOptionType["Default"] = 1] = "Default";
    EAppLaunchOptionType[EAppLaunchOptionType["SafeMode"] = 2] = "SafeMode";
    EAppLaunchOptionType[EAppLaunchOptionType["Multiplayer"] = 3] = "Multiplayer";
    EAppLaunchOptionType[EAppLaunchOptionType["Config"] = 4] = "Config";
    EAppLaunchOptionType[EAppLaunchOptionType["OpenVR"] = 5] = "OpenVR";
    EAppLaunchOptionType[EAppLaunchOptionType["Server"] = 6] = "Server";
    EAppLaunchOptionType[EAppLaunchOptionType["Editor"] = 7] = "Editor";
    EAppLaunchOptionType[EAppLaunchOptionType["Manual"] = 8] = "Manual";
    EAppLaunchOptionType[EAppLaunchOptionType["Benchmark"] = 9] = "Benchmark";
    EAppLaunchOptionType[EAppLaunchOptionType["Option1"] = 10] = "Option1";
    EAppLaunchOptionType[EAppLaunchOptionType["Option2"] = 11] = "Option2";
    EAppLaunchOptionType[EAppLaunchOptionType["Option3"] = 12] = "Option3";
    EAppLaunchOptionType[EAppLaunchOptionType["OculusVR"] = 13] = "OculusVR";
    EAppLaunchOptionType[EAppLaunchOptionType["OpenVROverlay"] = 14] = "OpenVROverlay";
    EAppLaunchOptionType[EAppLaunchOptionType["OSVR"] = 15] = "OSVR";
    EAppLaunchOptionType[EAppLaunchOptionType["OpenXR"] = 16] = "OpenXR";
    EAppLaunchOptionType[EAppLaunchOptionType["Dialog"] = 1000] = "Dialog";
})(EAppLaunchOptionType || (EAppLaunchOptionType = {}));
export var EWorkshopFileType;
(function (EWorkshopFileType) {
    EWorkshopFileType[EWorkshopFileType["Invalid"] = -1] = "Invalid";
    EWorkshopFileType[EWorkshopFileType["Community"] = 0] = "Community";
    EWorkshopFileType[EWorkshopFileType["Microtransaction"] = 1] = "Microtransaction";
    EWorkshopFileType[EWorkshopFileType["Collection"] = 2] = "Collection";
    EWorkshopFileType[EWorkshopFileType["Art"] = 3] = "Art";
    EWorkshopFileType[EWorkshopFileType["Video"] = 4] = "Video";
    EWorkshopFileType[EWorkshopFileType["Screenshot"] = 5] = "Screenshot";
    EWorkshopFileType[EWorkshopFileType["Game"] = 6] = "Game";
    EWorkshopFileType[EWorkshopFileType["Software"] = 7] = "Software";
    EWorkshopFileType[EWorkshopFileType["Concept"] = 8] = "Concept";
    EWorkshopFileType[EWorkshopFileType["WebGuide"] = 9] = "WebGuide";
    EWorkshopFileType[EWorkshopFileType["IntegratedGuide"] = 10] = "IntegratedGuide";
    EWorkshopFileType[EWorkshopFileType["Merch"] = 11] = "Merch";
    EWorkshopFileType[EWorkshopFileType["ControllerBinding"] = 12] = "ControllerBinding";
    EWorkshopFileType[EWorkshopFileType["SteamworksAccessInvite"] = 13] = "SteamworksAccessInvite";
    EWorkshopFileType[EWorkshopFileType["SteamVideo"] = 14] = "SteamVideo";
    EWorkshopFileType[EWorkshopFileType["GameManagedItem"] = 15] = "GameManagedItem";
    EWorkshopFileType[EWorkshopFileType["Max"] = 16] = "Max";
})(EWorkshopFileType || (EWorkshopFileType = {}));
export var EAppUpdateError;
(function (EAppUpdateError) {
    EAppUpdateError[EAppUpdateError["None"] = 0] = "None";
    EAppUpdateError[EAppUpdateError["Unspecified"] = 1] = "Unspecified";
    EAppUpdateError[EAppUpdateError["Paused"] = 2] = "Paused";
    EAppUpdateError[EAppUpdateError["Canceled"] = 3] = "Canceled";
    EAppUpdateError[EAppUpdateError["Suspended"] = 4] = "Suspended";
    EAppUpdateError[EAppUpdateError["NoSubscription"] = 5] = "NoSubscription";
    EAppUpdateError[EAppUpdateError["NoConnection"] = 6] = "NoConnection";
    EAppUpdateError[EAppUpdateError["Timeout"] = 7] = "Timeout";
    EAppUpdateError[EAppUpdateError["MissingKey"] = 8] = "MissingKey";
    EAppUpdateError[EAppUpdateError["MissingConfig"] = 9] = "MissingConfig";
    EAppUpdateError[EAppUpdateError["DiskReadFailure"] = 10] = "DiskReadFailure";
    EAppUpdateError[EAppUpdateError["DiskWriteFailure"] = 11] = "DiskWriteFailure";
    EAppUpdateError[EAppUpdateError["NotEnoughDiskSpace"] = 12] = "NotEnoughDiskSpace";
    EAppUpdateError[EAppUpdateError["CorruptGameFiles"] = 13] = "CorruptGameFiles";
    EAppUpdateError[EAppUpdateError["WaitingForNextDisk"] = 14] = "WaitingForNextDisk";
    EAppUpdateError[EAppUpdateError["InvalidInstallPath"] = 15] = "InvalidInstallPath";
    EAppUpdateError[EAppUpdateError["AppRunning"] = 16] = "AppRunning";
    EAppUpdateError[EAppUpdateError["DependencyFailure"] = 17] = "DependencyFailure";
    EAppUpdateError[EAppUpdateError["NotInstalled"] = 18] = "NotInstalled";
    EAppUpdateError[EAppUpdateError["UpdateRequired"] = 19] = "UpdateRequired";
    EAppUpdateError[EAppUpdateError["Busy"] = 20] = "Busy";
    EAppUpdateError[EAppUpdateError["NoDownloadSources"] = 21] = "NoDownloadSources";
    EAppUpdateError[EAppUpdateError["InvalidAppConfig"] = 22] = "InvalidAppConfig";
    EAppUpdateError[EAppUpdateError["InvalidDepotConfig"] = 23] = "InvalidDepotConfig";
    EAppUpdateError[EAppUpdateError["MissingManifest"] = 24] = "MissingManifest";
    EAppUpdateError[EAppUpdateError["NotReleased"] = 25] = "NotReleased";
    EAppUpdateError[EAppUpdateError["RegionRestricted"] = 26] = "RegionRestricted";
    EAppUpdateError[EAppUpdateError["CorruptDepotCache"] = 27] = "CorruptDepotCache";
    EAppUpdateError[EAppUpdateError["MissingExecutable"] = 28] = "MissingExecutable";
    EAppUpdateError[EAppUpdateError["InvalidPlatform"] = 29] = "InvalidPlatform";
    EAppUpdateError[EAppUpdateError["InvalidFileSystem"] = 30] = "InvalidFileSystem";
    EAppUpdateError[EAppUpdateError["CorruptUpdateFiles"] = 31] = "CorruptUpdateFiles";
    EAppUpdateError[EAppUpdateError["DownloadDisabled"] = 32] = "DownloadDisabled";
    EAppUpdateError[EAppUpdateError["SharedLibraryLocked"] = 33] = "SharedLibraryLocked";
    EAppUpdateError[EAppUpdateError["PendingLicense"] = 34] = "PendingLicense";
    EAppUpdateError[EAppUpdateError["OtherSessionPlaying"] = 35] = "OtherSessionPlaying";
    EAppUpdateError[EAppUpdateError["CorruptDownload"] = 36] = "CorruptDownload";
    EAppUpdateError[EAppUpdateError["CorruptDisk"] = 37] = "CorruptDisk";
    EAppUpdateError[EAppUpdateError["FilePermissions"] = 38] = "FilePermissions";
    EAppUpdateError[EAppUpdateError["FileLocked"] = 39] = "FileLocked";
    EAppUpdateError[EAppUpdateError["MissingContent"] = 40] = "MissingContent";
    EAppUpdateError[EAppUpdateError["Requires64BitOS"] = 41] = "Requires64BitOS";
    EAppUpdateError[EAppUpdateError["MissingUpdateFiles"] = 42] = "MissingUpdateFiles";
    EAppUpdateError[EAppUpdateError["NotEnoughDiskQuota"] = 43] = "NotEnoughDiskQuota";
    EAppUpdateError[EAppUpdateError["LockedSiteLicense"] = 44] = "LockedSiteLicense";
    EAppUpdateError[EAppUpdateError["ParentalControlBlocked"] = 45] = "ParentalControlBlocked";
    EAppUpdateError[EAppUpdateError["CreateProcessFailure"] = 46] = "CreateProcessFailure";
    EAppUpdateError[EAppUpdateError["SteamClientOutdated"] = 47] = "SteamClientOutdated";
    EAppUpdateError[EAppUpdateError["PlaytimeExceeded"] = 48] = "PlaytimeExceeded";
    EAppUpdateError[EAppUpdateError["CorruptFileSignature"] = 49] = "CorruptFileSignature";
    EAppUpdateError[EAppUpdateError["MissingInstalledFiles"] = 50] = "MissingInstalledFiles";
    EAppUpdateError[EAppUpdateError["CompatibilityToolFailure"] = 51] = "CompatibilityToolFailure";
    EAppUpdateError[EAppUpdateError["UnmountedUninstallPath"] = 52] = "UnmountedUninstallPath";
    EAppUpdateError[EAppUpdateError["InvalidBackupPath"] = 53] = "InvalidBackupPath";
    EAppUpdateError[EAppUpdateError["InvalidPasscode"] = 54] = "InvalidPasscode";
    EAppUpdateError[EAppUpdateError["ThirdPartyUpdater"] = 55] = "ThirdPartyUpdater";
    EAppUpdateError[EAppUpdateError["ParentalPlaytimeExceeded"] = 56] = "ParentalPlaytimeExceeded";
    EAppUpdateError[EAppUpdateError["Max"] = 57] = "Max";
})(EAppUpdateError || (EAppUpdateError = {}));
// TODO: not the actual name
export var ESteamInputController;
(function (ESteamInputController) {
    ESteamInputController[ESteamInputController["PlayStation"] = 1] = "PlayStation";
    ESteamInputController[ESteamInputController["Xbox"] = 2] = "Xbox";
    ESteamInputController[ESteamInputController["Generic"] = 4] = "Generic";
    ESteamInputController[ESteamInputController["NintendoSwitch"] = 8] = "NintendoSwitch";
})(ESteamInputController || (ESteamInputController = {}));
export var EAppOwnershipFlags;
(function (EAppOwnershipFlags) {
    EAppOwnershipFlags[EAppOwnershipFlags["None"] = 0] = "None";
    EAppOwnershipFlags[EAppOwnershipFlags["Subscribed"] = 1] = "Subscribed";
    EAppOwnershipFlags[EAppOwnershipFlags["Free"] = 2] = "Free";
    EAppOwnershipFlags[EAppOwnershipFlags["RegionRestricted"] = 4] = "RegionRestricted";
    EAppOwnershipFlags[EAppOwnershipFlags["LowViolence"] = 8] = "LowViolence";
    EAppOwnershipFlags[EAppOwnershipFlags["InvalidPlatform"] = 16] = "InvalidPlatform";
    EAppOwnershipFlags[EAppOwnershipFlags["Borrowed"] = 32] = "Borrowed";
    EAppOwnershipFlags[EAppOwnershipFlags["FreeWeekend"] = 64] = "FreeWeekend";
    EAppOwnershipFlags[EAppOwnershipFlags["Retail"] = 128] = "Retail";
    EAppOwnershipFlags[EAppOwnershipFlags["Locked"] = 256] = "Locked";
    EAppOwnershipFlags[EAppOwnershipFlags["Pending"] = 512] = "Pending";
    EAppOwnershipFlags[EAppOwnershipFlags["Expired"] = 1024] = "Expired";
    EAppOwnershipFlags[EAppOwnershipFlags["Permanent"] = 2048] = "Permanent";
    EAppOwnershipFlags[EAppOwnershipFlags["Recurring"] = 4096] = "Recurring";
    EAppOwnershipFlags[EAppOwnershipFlags["Canceled"] = 8192] = "Canceled";
    EAppOwnershipFlags[EAppOwnershipFlags["AutoGrant"] = 16384] = "AutoGrant";
    EAppOwnershipFlags[EAppOwnershipFlags["PendingGift"] = 32768] = "PendingGift";
    EAppOwnershipFlags[EAppOwnershipFlags["RentalNotActivated"] = 65536] = "RentalNotActivated";
    EAppOwnershipFlags[EAppOwnershipFlags["Rental"] = 131072] = "Rental";
    EAppOwnershipFlags[EAppOwnershipFlags["SiteLicense"] = 262144] = "SiteLicense";
    EAppOwnershipFlags[EAppOwnershipFlags["LegacyFreeSub"] = 524288] = "LegacyFreeSub";
    EAppOwnershipFlags[EAppOwnershipFlags["InvalidOSType"] = 1048576] = "InvalidOSType";
    EAppOwnershipFlags[EAppOwnershipFlags["TimedTrial"] = 2097152] = "TimedTrial";
})(EAppOwnershipFlags || (EAppOwnershipFlags = {}));
export var EAppAutoUpdateBehavior;
(function (EAppAutoUpdateBehavior) {
    EAppAutoUpdateBehavior[EAppAutoUpdateBehavior["Always"] = 0] = "Always";
    EAppAutoUpdateBehavior[EAppAutoUpdateBehavior["Launch"] = 1] = "Launch";
    EAppAutoUpdateBehavior[EAppAutoUpdateBehavior["HighPriority"] = 2] = "HighPriority";
})(EAppAutoUpdateBehavior || (EAppAutoUpdateBehavior = {}));
export var EAppAllowDownloadsWhileRunningBehavior;
(function (EAppAllowDownloadsWhileRunningBehavior) {
    EAppAllowDownloadsWhileRunningBehavior[EAppAllowDownloadsWhileRunningBehavior["UseGlobal"] = 0] = "UseGlobal";
    EAppAllowDownloadsWhileRunningBehavior[EAppAllowDownloadsWhileRunningBehavior["AlwaysAllow"] = 1] = "AlwaysAllow";
    EAppAllowDownloadsWhileRunningBehavior[EAppAllowDownloadsWhileRunningBehavior["NeverAllow"] = 2] = "NeverAllow";
})(EAppAllowDownloadsWhileRunningBehavior || (EAppAllowDownloadsWhileRunningBehavior = {}));
export var EDisplayStatus;
(function (EDisplayStatus) {
    EDisplayStatus[EDisplayStatus["Invalid"] = 0] = "Invalid";
    EDisplayStatus[EDisplayStatus["Launching"] = 1] = "Launching";
    EDisplayStatus[EDisplayStatus["Uninstalling"] = 2] = "Uninstalling";
    EDisplayStatus[EDisplayStatus["Installing"] = 3] = "Installing";
    EDisplayStatus[EDisplayStatus["Running"] = 4] = "Running";
    EDisplayStatus[EDisplayStatus["Validating"] = 5] = "Validating";
    EDisplayStatus[EDisplayStatus["Updating"] = 6] = "Updating";
    EDisplayStatus[EDisplayStatus["Downloading"] = 7] = "Downloading";
    EDisplayStatus[EDisplayStatus["Synchronizing"] = 8] = "Synchronizing";
    EDisplayStatus[EDisplayStatus["ReadyToInstall"] = 9] = "ReadyToInstall";
    EDisplayStatus[EDisplayStatus["ReadyToPreload"] = 10] = "ReadyToPreload";
    EDisplayStatus[EDisplayStatus["ReadyToLaunch"] = 11] = "ReadyToLaunch";
    EDisplayStatus[EDisplayStatus["RegionRestricted"] = 12] = "RegionRestricted";
    EDisplayStatus[EDisplayStatus["PresaleOnly"] = 13] = "PresaleOnly";
    EDisplayStatus[EDisplayStatus["InvalidPlatform"] = 14] = "InvalidPlatform";
    // ty valve
    EDisplayStatus[EDisplayStatus["PreloadComplete"] = 16] = "PreloadComplete";
    EDisplayStatus[EDisplayStatus["BorrowerLocked"] = 17] = "BorrowerLocked";
    EDisplayStatus[EDisplayStatus["UpdatePaused"] = 18] = "UpdatePaused";
    EDisplayStatus[EDisplayStatus["UpdateQueued"] = 19] = "UpdateQueued";
    EDisplayStatus[EDisplayStatus["UpdateRequired"] = 20] = "UpdateRequired";
    EDisplayStatus[EDisplayStatus["UpdateDisabled"] = 21] = "UpdateDisabled";
    EDisplayStatus[EDisplayStatus["DownloadPaused"] = 22] = "DownloadPaused";
    EDisplayStatus[EDisplayStatus["DownloadQueued"] = 23] = "DownloadQueued";
    EDisplayStatus[EDisplayStatus["DownloadRequired"] = 24] = "DownloadRequired";
    EDisplayStatus[EDisplayStatus["DownloadDisabled"] = 25] = "DownloadDisabled";
    EDisplayStatus[EDisplayStatus["LicensePending"] = 26] = "LicensePending";
    EDisplayStatus[EDisplayStatus["LicenseExpired"] = 27] = "LicenseExpired";
    EDisplayStatus[EDisplayStatus["AvailForFree"] = 28] = "AvailForFree";
    EDisplayStatus[EDisplayStatus["AvailToBorrow"] = 29] = "AvailToBorrow";
    EDisplayStatus[EDisplayStatus["AvailGuestPass"] = 30] = "AvailGuestPass";
    EDisplayStatus[EDisplayStatus["Purchase"] = 31] = "Purchase";
    EDisplayStatus[EDisplayStatus["Unavailable"] = 32] = "Unavailable";
    EDisplayStatus[EDisplayStatus["NotLaunchable"] = 33] = "NotLaunchable";
    EDisplayStatus[EDisplayStatus["CloudError"] = 34] = "CloudError";
    EDisplayStatus[EDisplayStatus["CloudOutOfDate"] = 35] = "CloudOutOfDate";
    EDisplayStatus[EDisplayStatus["Terminating"] = 36] = "Terminating";
    EDisplayStatus[EDisplayStatus["OwnerLocked"] = 37] = "OwnerLocked";
    EDisplayStatus[EDisplayStatus["DownloadFailed"] = 38] = "DownloadFailed";
    EDisplayStatus[EDisplayStatus["UpdateFailed"] = 39] = "UpdateFailed";
})(EDisplayStatus || (EDisplayStatus = {}));
export var ESteamDeckCompatibilityTestResult;
(function (ESteamDeckCompatibilityTestResult) {
    ESteamDeckCompatibilityTestResult[ESteamDeckCompatibilityTestResult["Invalid"] = 0] = "Invalid";
    ESteamDeckCompatibilityTestResult[ESteamDeckCompatibilityTestResult["NotApplicable"] = 1] = "NotApplicable";
    ESteamDeckCompatibilityTestResult[ESteamDeckCompatibilityTestResult["Pass"] = 2] = "Pass";
    ESteamDeckCompatibilityTestResult[ESteamDeckCompatibilityTestResult["Fail"] = 3] = "Fail";
    ESteamDeckCompatibilityTestResult[ESteamDeckCompatibilityTestResult["FailMinor"] = 4] = "FailMinor";
})(ESteamDeckCompatibilityTestResult || (ESteamDeckCompatibilityTestResult = {}));
export var ELaunchSource;
(function (ELaunchSource) {
    ELaunchSource[ELaunchSource["None"] = 0] = "None";
    ELaunchSource[ELaunchSource["_2ftLibraryDetails"] = 100] = "_2ftLibraryDetails";
    ELaunchSource[ELaunchSource["_2ftLibraryListView"] = 101] = "_2ftLibraryListView";
    ELaunchSource[ELaunchSource["_2ftLibraryGrid"] = 102] = "_2ftLibraryGrid";
    ELaunchSource[ELaunchSource["InstallSubComplete"] = 103] = "InstallSubComplete";
    ELaunchSource[ELaunchSource["DownloadsPage"] = 104] = "DownloadsPage";
    ELaunchSource[ELaunchSource["RemoteClientStartStreaming"] = 105] = "RemoteClientStartStreaming";
    ELaunchSource[ELaunchSource["_2ftMiniModeList"] = 106] = "_2ftMiniModeList";
    ELaunchSource[ELaunchSource["_10ft"] = 200] = "_10ft";
    ELaunchSource[ELaunchSource["DashAppLaunchCmdLine"] = 300] = "DashAppLaunchCmdLine";
    ELaunchSource[ELaunchSource["DashGameIdLaunchCmdLine"] = 301] = "DashGameIdLaunchCmdLine";
    ELaunchSource[ELaunchSource["RunByGameDir"] = 302] = "RunByGameDir";
    ELaunchSource[ELaunchSource["SubCmdRunDashGame"] = 303] = "SubCmdRunDashGame";
    ELaunchSource[ELaunchSource["SteamURL_Launch"] = 400] = "SteamURL_Launch";
    ELaunchSource[ELaunchSource["SteamURL_Run"] = 401] = "SteamURL_Run";
    ELaunchSource[ELaunchSource["SteamURL_JoinLobby"] = 402] = "SteamURL_JoinLobby";
    ELaunchSource[ELaunchSource["SteamURL_RunGame"] = 403] = "SteamURL_RunGame";
    ELaunchSource[ELaunchSource["SteamURL_RunGameIdOrJumplist"] = 404] = "SteamURL_RunGameIdOrJumplist";
    ELaunchSource[ELaunchSource["SteamURL_RunSafe"] = 405] = "SteamURL_RunSafe";
    ELaunchSource[ELaunchSource["TrayIcon"] = 500] = "TrayIcon";
    ELaunchSource[ELaunchSource["LibraryLeftColumnContextMenu"] = 600] = "LibraryLeftColumnContextMenu";
    ELaunchSource[ELaunchSource["LibraryLeftColumnDoubleClick"] = 601] = "LibraryLeftColumnDoubleClick";
    ELaunchSource[ELaunchSource["Dota2Launcher"] = 700] = "Dota2Launcher";
    ELaunchSource[ELaunchSource["IRunGameEngine"] = 800] = "IRunGameEngine";
    ELaunchSource[ELaunchSource["DRMFailureResponse"] = 801] = "DRMFailureResponse";
    ELaunchSource[ELaunchSource["DRMDataRequest"] = 802] = "DRMDataRequest";
    ELaunchSource[ELaunchSource["CloudFilePanel"] = 803] = "CloudFilePanel";
    ELaunchSource[ELaunchSource["DiscoveredAlreadyRunning"] = 804] = "DiscoveredAlreadyRunning";
    ELaunchSource[ELaunchSource["GameActionJoinParty"] = 900] = "GameActionJoinParty";
    ELaunchSource[ELaunchSource["AppPortraitContextMenu"] = 1000] = "AppPortraitContextMenu";
})(ELaunchSource || (ELaunchSource = {}));
export var ECloudPendingRemoteOperation;
(function (ECloudPendingRemoteOperation) {
    ECloudPendingRemoteOperation[ECloudPendingRemoteOperation["None"] = 0] = "None";
    ECloudPendingRemoteOperation[ECloudPendingRemoteOperation["AppSessionActive"] = 1] = "AppSessionActive";
    ECloudPendingRemoteOperation[ECloudPendingRemoteOperation["UploadInProgress"] = 2] = "UploadInProgress";
    ECloudPendingRemoteOperation[ECloudPendingRemoteOperation["UploadPending"] = 3] = "UploadPending";
    ECloudPendingRemoteOperation[ECloudPendingRemoteOperation["AppSessionSuspended"] = 4] = "AppSessionSuspended";
})(ECloudPendingRemoteOperation || (ECloudPendingRemoteOperation = {}));
export var EAppType;
(function (EAppType) {
    EAppType[EAppType["DepotOnly"] = -2147483648] = "DepotOnly";
    EAppType[EAppType["Invalid"] = 0] = "Invalid";
    EAppType[EAppType["Game"] = 1] = "Game";
    EAppType[EAppType["Application"] = 2] = "Application";
    EAppType[EAppType["Tool"] = 4] = "Tool";
    EAppType[EAppType["Demo"] = 8] = "Demo";
    EAppType[EAppType["Deprecated"] = 16] = "Deprecated";
    EAppType[EAppType["DLC"] = 32] = "DLC";
    EAppType[EAppType["Guide"] = 64] = "Guide";
    EAppType[EAppType["Driver"] = 128] = "Driver";
    EAppType[EAppType["Config"] = 256] = "Config";
    EAppType[EAppType["Hardware"] = 512] = "Hardware";
    EAppType[EAppType["Franchise"] = 1024] = "Franchise";
    EAppType[EAppType["Video"] = 2048] = "Video";
    EAppType[EAppType["Plugin"] = 4096] = "Plugin";
    EAppType[EAppType["MusicAlbum"] = 8192] = "MusicAlbum";
    EAppType[EAppType["Series"] = 16384] = "Series";
    EAppType[EAppType["Comic"] = 32768] = "Comic";
    EAppType[EAppType["Beta"] = 65536] = "Beta";
    EAppType[EAppType["Shortcut"] = 1073741824] = "Shortcut";
})(EAppType || (EAppType = {}));
export var EAppAssociationType;
(function (EAppAssociationType) {
    EAppAssociationType[EAppAssociationType["Invalid"] = 0] = "Invalid";
    EAppAssociationType[EAppAssociationType["Publisher"] = 1] = "Publisher";
    EAppAssociationType[EAppAssociationType["Developer"] = 2] = "Developer";
    EAppAssociationType[EAppAssociationType["Franchise"] = 3] = "Franchise";
})(EAppAssociationType || (EAppAssociationType = {}));
export var EAppControllerSupportLevel;
(function (EAppControllerSupportLevel) {
    EAppControllerSupportLevel[EAppControllerSupportLevel["None"] = 0] = "None";
    EAppControllerSupportLevel[EAppControllerSupportLevel["Partial"] = 1] = "Partial";
    EAppControllerSupportLevel[EAppControllerSupportLevel["Full"] = 2] = "Full";
})(EAppControllerSupportLevel || (EAppControllerSupportLevel = {}));
export var ESteamDeckCompatibilityCategory;
(function (ESteamDeckCompatibilityCategory) {
    ESteamDeckCompatibilityCategory[ESteamDeckCompatibilityCategory["Unknown"] = 0] = "Unknown";
    ESteamDeckCompatibilityCategory[ESteamDeckCompatibilityCategory["Unsupported"] = 1] = "Unsupported";
    ESteamDeckCompatibilityCategory[ESteamDeckCompatibilityCategory["Playable"] = 2] = "Playable";
    ESteamDeckCompatibilityCategory[ESteamDeckCompatibilityCategory["Verified"] = 3] = "Verified";
})(ESteamDeckCompatibilityCategory || (ESteamDeckCompatibilityCategory = {}));
export var EAppCloudStatus;
(function (EAppCloudStatus) {
    EAppCloudStatus[EAppCloudStatus["Invalid"] = 0] = "Invalid";
    EAppCloudStatus[EAppCloudStatus["Disabled"] = 1] = "Disabled";
    EAppCloudStatus[EAppCloudStatus["Unknown"] = 2] = "Unknown";
    EAppCloudStatus[EAppCloudStatus["Synchronized"] = 3] = "Synchronized";
    EAppCloudStatus[EAppCloudStatus["Checking"] = 4] = "Checking";
    EAppCloudStatus[EAppCloudStatus["OutOfSync"] = 5] = "OutOfSync";
    EAppCloudStatus[EAppCloudStatus["Uploading"] = 6] = "Uploading";
    EAppCloudStatus[EAppCloudStatus["Downloading"] = 7] = "Downloading";
    EAppCloudStatus[EAppCloudStatus["SyncFailed"] = 8] = "SyncFailed";
    EAppCloudStatus[EAppCloudStatus["Conflict"] = 9] = "Conflict";
    EAppCloudStatus[EAppCloudStatus["PendingElsewhere"] = 10] = "PendingElsewhere";
})(EAppCloudStatus || (EAppCloudStatus = {}));
export var ERaiseGameWindowResult;
(function (ERaiseGameWindowResult) {
    ERaiseGameWindowResult[ERaiseGameWindowResult["NotRunning"] = 1] = "NotRunning";
    ERaiseGameWindowResult[ERaiseGameWindowResult["Success"] = 2] = "Success";
    ERaiseGameWindowResult[ERaiseGameWindowResult["Failure"] = 3] = "Failure";
})(ERaiseGameWindowResult || (ERaiseGameWindowResult = {}));
